import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LeaseExpirationDto, LandTitleDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-lease-expiration-container',
  templateUrl: './lease-expiration-container.component.html',
  styleUrls: ['./lease-expiration-container.component.scss']
})
export class LeaseExpirationContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  landtitles$: Observable<LandTitleDto[]>;
  countries$: Observable<LeaseExpirationDto[]>;
  loading: boolean;
  isLoadingLandTitle$: Observable<boolean>;
  isLoadingLeaseExpiration$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingLandTitle$ = this.gatwayFacade.isLoadingGateway("LandTitle");
    this.isLoadingLeaseExpiration$ = this.gatwayFacade.isLoadingGateway("LeaseExpiration");

    this.landtitles$ = this.gatwayFacade.loadGateway("LandTitle");
    this.countries$ = this.gatwayFacade.loadGateway("LeaseExpiration");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLeaseExpiration(deletedValue: any) {
    this.gatwayFacade.remove("LeaseExpiration", deletedValue);
  }

// this method control both the create and update
  onSubmitLeaseExpiration(formValue: any) {
    const pullData = formValue.Countries;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllLeaseExpiration = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllLeaseExpiration.push(pullData[i]);
    }
  }

// check if the addAllLeaseExpiration array is not empty, then dispatch the data to the store
   if(addAllLeaseExpiration.length > 0) {
    this.gatwayFacade.add('LeaseExpiration', addAllLeaseExpiration);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('LeaseExpiration', allUpdates, ['id']);
   }
  }


}